import React from "react";
import { cn } from "../lib/utils";
import { statusVariant } from "../lib/format";
import { titleCase } from "../lib/format";

const VARIANT_STYLES = {
  success: "bg-[hsl(var(--status-success-bg))] text-[hsl(var(--status-success-text))] border-[hsl(var(--status-success-border))]",
  warning: "bg-[hsl(var(--status-warning-bg))] text-[hsl(var(--status-warning-text))] border-[hsl(var(--status-warning-border))]",
  danger: "bg-[hsl(var(--status-danger-bg))] text-[hsl(var(--status-danger-text))] border-[hsl(var(--status-danger-border))]",
  neutral: "bg-[hsl(var(--status-neutral-bg))] text-[hsl(var(--status-neutral-text))] border-[hsl(var(--status-neutral-border))]",
};

export function StatusBadge({ status, label, variant, className, testId }) {
  const v = variant || statusVariant(status);
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-full border text-xs font-medium whitespace-nowrap",
        VARIANT_STYLES[v] || VARIANT_STYLES.neutral,
        className
      )}
    >
      <span className="mr-1.5 inline-block w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {label || titleCase(status || "")}
    </span>
  );
}
